const fonts = {
  primary: '"Playfair Display", serif',
  secondary: '"Work Sans", sans-serif',
};
export default fonts;
